/**
 * 从动画是否写运行时E2E的角度，将动画类型分为以下三类：
 * 1、新增的未上线的动画
 *      - 该类动画若不写E2E，会有以下问题：
 *      1、虽不会阻止向分支提交代码，但会在commit时提示位需补齐E2E
 *      2、不会影响代码部署，但是会在代码检查时提示“动画E2E覆盖检查”失败，阻止合入master
 * 2、已经上线，但需要补充E2E测试的动画
 *     - 为了不影响开发体验，该类动画不会在commit时提示，也不会在oci中提示检查失败；
 *     - 该类动画会在开发环境，代码运行时提示“需要补齐E2E”，待全部补齐后，下掉该提示
 * 3、已经上线，且已写E2E的动画
 */

const animsWithE2E = [
    'fly_in',
    'entr_stretch',
    'cycle',
    'arc',
    'entr_blinds',
    'exit_blinds',
    'exit_boomerang',
    'fill_color',
    'font_color',
    'scale',
];

const animsWithoutE2E = [
    'fade_in',
    'fade_out',
    'appear',
    'disappear',
    'fly_out',
    'float_up_in',
    'float_up_out',
    'float_down_in',
    'float_down_out',
    'cut_in',
    'cut_out',
    'rotate',
    'pluse',
    'spread',
    'entr_rotate',
    'entr_scale',
    'exit_spread',
    'exit_rotate',
    'exit_scale',
    'entr_center_revolve',
    'entr_grow_turn',
    'entr_rise_up',
    'entr_spinner',
    'entr_basic_zoom',
    'exit_center_revolve',
    'exit_shrink_turn',
    'exit_sink_down',
    'exit_spinner',
    'exit_basic_zoom',
    'exit_stretch',
    'exit_collapse',
    'entr_boomerang',
    'entr_pinwheel',
    'entr_basic_swivel',
    'exit_pinwheel',
    'exit_basic_swivel',
    'emph_transparency',
    'line_color',
    'brush_color',
    'complementary_color',
    'complementary_color2',
    'contrasting_color',
    'darken',
    'desaturate',
    'lighten',
    'object_color',
    'color_pulse',
    'grow_with_color',
    'shimmer',
    'teeter',
    'blink',
    'bold_reveal',
    'wave',
    'bold_flash',
    'underline',
    'straight_line',
    'shape',
    'turn',
    'custom',
    'entr_credits',
    'exit_credits',
    'entr_float',
    'exit_float',
    'entr_checkerboard',
    'exit_checkerboard',
    'curve_up',
    'curve_down',
    'entr_wipe',
    'exit_wipe',
    'entr_random_bars',
    'exit_random_bars',
    'dissolve_in',
    'dissolve_out',
    'entr_split',
    'exit_split',
    'entr_strips',
    'exit_strips',
    'entr_shape_circle',
    'exit_shape_circle',
    'entr_shape_box',
    'exit_shape_box',
    'entr_shape_diamond',
    'exit_shape_diamond',
    'entr_shape_plus',
    'exit_shape_plus',
    'entr_wedge',
    'exit_wedge',
    'entr_wheel',
    'exit_wheel',
    'entr_bounce',
    'exit_bounce',
    'sprial_in',
    'sprial_out',
    'play',
    'pause',
    'stop',
];

module.exports = {
    animsWithE2E,
    animsWithoutE2E,
}
